import React from "react";
import {
  AHIcon,
  AHText,
  Box,
  TouchableBox,
  useLayoutContext,
  useTheme,
} from "arkh";
import { AHNavigationHeaderContainer } from "../../../TopLevelNavigators/AHNavigationHeaderContainer";

import { graphql, useFragment } from "react-relay";
import { TeamScheduleHeader_team$key } from "./__generated__/TeamScheduleHeader_team.graphql";
import { HasPermission } from "../../../OS/Login/usePermissions";
import { TeamScheduleHeader_store$key } from "./__generated__/TeamScheduleHeader_store.graphql";
import { isDarkColor } from "./TeamHome/isDarkColor";
import { TeamHeaderButton } from "./TeamHome/TeamHeader/TeamHeaderButton";

export function TeamScheduleNavigationHeader(props: {
  team: TeamScheduleHeader_team$key;
  store: TeamScheduleHeader_store$key;
  onPressBack: () => void;
  onPressAdmin: (teamId: string) => void;
  onPressSupport: (teamId: string) => void;
}) {
  const store = useFragment(
    graphql`
      fragment TeamScheduleHeader_store on Store {
        ...usePermissions_store
      }
    `,
    props.store
  );
  const team = useFragment(
    graphql`
      fragment TeamScheduleHeader_team on Team {
        id
        name
        color
      }
    `,
    props.team
  );

  const layout = useLayoutContext();
  const theme = useTheme();
  const teamColor = team.color ?? theme.primary;
  const darkColor = isDarkColor(teamColor);
  const tintColor = darkColor ? "text-inverted" : "text-primary";
  return (
    <AHNavigationHeaderContainer
      style={{
        backgroundColor: teamColor,
      }}
    >
      <Box style={{ flex: 1 }}>
        <TouchableBox
          spaceLeft="medium"
          spaceRight="xsmall"
          onPress={() => props.onPressBack()}
          style={{
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <AHIcon type="chevron-left" size="xlarge" color={tintColor} />
          <AHText
            type="title-small"
            color={tintColor}
            numberOfLines={1}
            ellipsizeMode="tail"
            style={{
              flexDirection: "row",
            }}
          >
            {team.name}
          </AHText>
        </TouchableBox>
      </Box>

      <HasPermission permission="ROUTINE_ADMIN" store={store}>
        <TeamHeaderButton
          tintColor={tintColor}
          onPress={() => {
            props.onPressAdmin(team.id);
          }}
          title="Admin"
          containerStyle={{
            paddingHorizontal: layout.space.small,
          }}
          spaceRight="small"
          spaceLeft="medium"
        />
      </HasPermission>
      <TeamHeaderButton
        icon="help"
        onPress={() => {
          props.onPressSupport(team.id);
        }}
        tintColor={tintColor}
        spaceRight="medium"
        spaceLeft="small"
      />
    </AHNavigationHeaderContainer>
  );
}
